import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { actualizarSocio, obtenerSocioPorId } from '../services/sociosService'
import SocioForm from '../components/socios/SocioForm'

export default function EditarSocioPage() {
  const { id } = useParams()
  const { organizacion } = useAuth()
  const navigate = useNavigate()
  const [socio, setSocio] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    obtenerSocioPorId(organizacion.id, id)
      .then((result) => { if (active) setSocio(result) })
      .catch((loadError) => { if (active) setError(loadError.message) })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [organizacion.id, id])

  async function handleSubmit(values) {
    const updated = await actualizarSocio(organizacion.id, id, values)
    navigate(`/socios/${updated.id}`, { replace: true, state: { message: 'Socio actualizado correctamente.' } })
  }

  if (loading) return <div className="py-16 text-center text-sm text-text-secondary">Cargando socio…</div>
  if (!socio) return <div className="rounded-2xl border border-danger/25 bg-danger/5 p-6 text-danger" role="alert">{error || 'Socio no encontrado.'}</div>

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <div><p className="text-sm font-semibold text-primary">Socios</p><h2 className="mt-1 text-3xl font-bold tracking-tight">Editar socio</h2><p className="mt-2 text-text-secondary">Actualiza los datos del socio seleccionado.</p></div>
      <SocioForm initialValues={socio} onSubmit={handleSubmit} onCancel={() => navigate(`/socios/${id}`)} submitLabel="Guardar cambios" />
    </div>
  )
}
